
































import { Component, Vue, Emit } from "vue-property-decorator";

@Component
export default class FileDrop extends Vue {
  fileupload!: HTMLElement;
  dragover = false;

  mounted() {
    /*
      Access dropzone and fileupload with $el,
      because @Ref allow us to access the Vue component
      instead of the underlying HTML elements directly.
    */
    const dropzone = this.$el;
    const fileupload = this.$el.firstElementChild as HTMLElement;
    this.fileupload = fileupload;

    // register listeners on the dropzone / v-sheet
    if (dropzone) {
      // register all drag & drop event listeners
      dropzone.addEventListener("dragenter", e => {
        e.preventDefault();
        this.dragover = true;
      });
      dropzone.addEventListener("dragleave", e => {
        e.preventDefault();
        this.dragover = false;
      });
      dropzone.addEventListener("dragover", e => {
        e.preventDefault();
        this.dragover = true;
      });
      dropzone.addEventListener("drop", e => {
        e.preventDefault();
        const dragevent = e as DragEvent;
        if (dragevent.dataTransfer) {
          this.filesSelected(dragevent.dataTransfer.files);
        }
      });

      // register listeners on the file input
      if (fileupload) {
        fileupload.addEventListener("change", e => {
          const target = e.target as HTMLInputElement;
          if (target.files && target.files.length) {
            this.filesSelected(target.files);
          }
        });
      }
    }
  }

  get iconColor() {
    return this.dragover ? "grey darken-2" : "grey";
  }

  get textColor() {
    return this.dragover ? "text--darken-4" : "text--darken-2";
  }

  @Emit()
  filesSelected(fileList: FileList) {
    this.dragover = false;
    return fileList;
  }
}
